
import { getAccessToken } from "./api/getAccessTokenSilently";

import { msalConfig } from "./auth-config";
import { PublicClientApplication } from "@azure/msal-browser";

const msalInstance = new PublicClientApplication(msalConfig);

const getCurrentAccount = () => {
  const accounts = msalInstance.getAllAccounts();
  return accounts.length > 0 ? accounts[0] : null;
};

const getUserEmail = () => {
  const account = getCurrentAccount();
  return account?.username || "";
};

// const API_ENDPOINTS = {
//   TOKEN:
//     "https://q54lderfwbhrpereajs6fvethu0ebrsk.lambda-url.ap-south-1.on.aws/wwf/token",
//   PROJECTS:
//     "https://q54lderfwbhrpereajs6fvethu0ebrsk.lambda-url.ap-south-1.on.aws/wwf/projects",
//   PROJECT_CATEGORIES:
//     "https://q54lderfwbhrpereajs6fvethu0ebrsk.lambda-url.ap-south-1.on.aws/wwf/project-categories",
// };






// export const fetchToken = async () => {
//   try {
//     const token = await getAccessToken();//auth
   
//     const response = await fetch(API_ENDPOINTS.TOKEN, {
//       method: "POST",
//       headers: {
//         "Authorization": `Bearer ${token}`,//auth
//         "Content-Type": "application/json",
//       },
//       body: JSON.stringify({ token: "india-wwf-api-key-9X47QZ" }),
//     });
//     const data = await response.json();
//     if (data.access_token) {
      
//       sessionStorage.setItem("wwf_token", data.access_token);
//       return data.access_token;
//     }
//     throw new Error("Token not received");
//   } catch (error) {
//     console.error("Error fetching token:", error);
//     throw error;
//   }
// };

// export const fetchProjects = async () => {
//   try {
//     const token = await getAccessToken();//auth
    
//     console.log("Access Token:", token);
//     const response = await fetch(API_ENDPOINTS.PROJECTS, {
//       method: "POST",
//       headers: {
//         "Authorization": `Bearer ${token}`,//auth
//         "Content-Type": "application/json",
//       },
//       body: JSON.stringify({ token: "india-wwf-api-key-9X47QZ" }),
//     });
//     const data = await response.json();
//     return data;
//   } catch (error) {
//     console.error("Error fetching projects:", error);
//     throw error;
//   }
// };

// export const fetchProjectCategories = async (projectId) => {
//   try {
//     const token = await getAccessToken();//auth
   
//     const response = await fetch(API_ENDPOINTS.PROJECT_CATEGORIES, {
//       method: "POST",
//       headers: {
//         "Authorization": `Bearer ${token}`,//auth
//         "Content-Type": "application/json",
//       },
//       body: JSON.stringify({
//         token: "india-wwf-api-key-9X47QZ",
//         projectId,
//       }),
//     });
//     const data = await response.json();
//     return data;
//   } catch (error) {
//     console.error("Error fetching project categories:", error);
//     throw error;
//   }
// };

//-------------------------------------------------------------------------------------------------
export const getLandscape = async (division) => {
  try {
    const token = await getAccessToken();//auth
    const userId = getUserEmail();
    //console.log("Access Token:", token);
    const response = await fetch("https://q54lderfwbhrpereajs6fvethu0ebrsk.lambda-url.ap-south-1.on.aws/WWF-V2/landscapes", {
      method: "POST",
      headers: {
        "Authorization": `Bearer ${token}`,//auth
        "Content-Type": "application/json",
      },
     // body: JSON.stringify({ token: "india-wwf-api-key-9X47QZ" }),
     body: JSON.stringify({
        division,userId
      }),
    });
    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error fetching projects:", error);
    throw error;
  }
};

export const getDivision = async () => {
  try {
    const token = await getAccessToken();//auth
    const userId = getUserEmail();
    //console.log("Access Token:", token);
    //console.log("Email being sent in header:", userId);
    const response = await fetch("https://q54lderfwbhrpereajs6fvethu0ebrsk.lambda-url.ap-south-1.on.aws/WWF-V2/divisions", {
      method: "POST",
      headers: {
        "Authorization": `Bearer ${token}`,//auth
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ userId }),
    });
    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error fetching projects:", error);
    throw error;
  }
};



export const getProjects = async (division = "",landscape = "") => {
  try {
    const token = await getAccessToken();//auth
    const userId = getUserEmail();
    //console.log("Access Token:", token);
    const response = await fetch("https://q54lderfwbhrpereajs6fvethu0ebrsk.lambda-url.ap-south-1.on.aws/WWF-V2/projects", {
      method: "POST",
      headers: {
        "Authorization": `Bearer ${token}`,//auth
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        division,
        landscape,
        userId
      }),
    });
    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error fetching projects:", error);
    throw error;
  }
};


// export const getProjectCategories1 = async (projectId) => {
//   try {
//     const token = await getAccessToken();//auth
//     //const email = getUserEmail();
//     const response = await fetch("https://localhost:7018/WWFControllerNew/project-categories-singleProject", {
//       method: "POST",
//       headers: {
//         "Authorization": `Bearer ${token}`,//auth
//         "Content-Type": "application/json",
//       },
//       body: JSON.stringify({
//         //token: "india-wwf-api-key-9X47QZ",
//         projectId,
//       }),
//     });
//     const data = await response.json();
//     return data;
//   } catch (error) {
//     console.error("Error fetching project categories:", error);
//     throw error;
//   }
// };

export const getProjectCategories = async (projectId) => {
  try {
    const token = await getAccessToken();//auth
    //const email = getUserEmail();
    const response = await fetch("https://q54lderfwbhrpereajs6fvethu0ebrsk.lambda-url.ap-south-1.on.aws/WWF-V2/project-categories", {
      method: "POST",
      headers: {
        "Authorization": `Bearer ${token}`,//auth
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        //token: "india-wwf-api-key-9X47QZ",
        projectId,
      }),
    });
    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error fetching project categories:", error);
    throw error;
  }
};


